import type { AutosaveState } from "@hq/client";
import { useSyncExternalStore } from "react";
import { useAutosave } from "./provider";

/** `idle | dirty | saving | saved | error` for one note. `saved` means committed to the local store. */
export function useAutosaveState(noteId: string): AutosaveState {
  const autosave = useAutosave();
  return useSyncExternalStore(
    (onChange) => autosave.subscribe(noteId, onChange),
    () => autosave.getState(noteId),
    () => autosave.getState(noteId),
  );
}
